var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "equiposPerifericos" }, [
    _c(
      "div",
      {
        staticClass: "gridcard rounded-card",
        staticStyle: { "padding-top": "6px", "padding-right": "0px" },
        attrs: { align: "left" }
      },
      [
        _c(
          "v-flex",
          { attrs: { sm12: "", md12: "" } },
          [
            _c(
              "v-container",
              {
                staticClass: "pa-0",
                staticStyle: {
                  "padding-top": "30px",
                  "min-height": "calc(100vh - 50px)"
                },
                attrs: { "grid-list-md": "", fluid: "" }
              },
              [
                _c(
                  "v-layout",
                  {
                    attrs: {
                      row: "",
                      wrap: "",
                      "align-center": "",
                      "justify-center": ""
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticStyle: { "padding-top": "20px" },
                        attrs: { xs12: "", md3: "" }
                      },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: "Orden de Servicio",
                            items: _vm.ordenesServicio,
                            "item-text": "altaserorden_numero",
                            "item-value": "altaserorden_numero",
                            "no-data-text": "Sin resultados"
                          },
                          on: { change: _vm.actualizarPDF },
                          model: {
                            value: _vm.selectedOrdenServicio,
                            callback: function($$v) {
                              _vm.selectedOrdenServicio = $$v
                            },
                            expression: "selectedOrdenServicio"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.url
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          position: "relative",
                          "padding-top": "5px",
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "flex-start",
                          height: "calc(100vh - 50px)"
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "loader",
                          staticStyle: {
                            position: "absolute",
                            "z-index": "0",
                            top: "100px"
                          }
                        }),
                        _c("embed", {
                          staticStyle: {
                            width: "80%",
                            height: "calc(100vh - 60px)",
                            position: "absolute",
                            "z-index": "1"
                          },
                          attrs: { src: _vm.url, type: "application/pdf" }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }